// extracted by mini-css-extract-plugin
export default {"treeWrapper":"DcCzp"};